<template>
  <section class="tableWrap">
    <div class="dashWrap">
      <div class="dashRow">
        <h2 class="tit">{{present.title}} 주문 정보</h2>
        <div class="dashBx">
          <div class="formInfo">
            <v-form ref="formOrder">
              <dl class="infoCont">
                <dt class="formInfoTxt small">배송지 주소 <i class="fa fa-asterisk" aria-hidden="true"/>
                  <v-btn color="info" @click="setUserInfo" dark small>
                    <v-icon small class="mr-2">mdi mdi-account</v-icon>
                     회원 정보
                  </v-btn>
                </dt>
                <dd class="formInfoArea">
                  <v-col class="d-flex">
                    <v-text-field type="number" v-model="order.zipCode" label="우편번호"
                                  @click="openZipCode"
                                  v-on:keyup.13="openZipCode"
                                  maxlength="6"
                                  :rules="[
                                              rules.required,
                                              value => !!value && value.length >= 5 && value.length <= 6 || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
                                              ]"
                                  style="max-width: 120px; padding-right: 10px"
                    />
                    <v-text-field v-model="order.address" :rules="[rules.required]" label="주소" style="padding-right: 10px"/>
                    <v-text-field v-model="order.addressDetail" label="주소상세"/>
                    <v-dialog v-model="daumDialogVisible" max-width="500px" @click:outside="daumDialogVisible=false" @keydown.esc="daumDialogVisible=false">
                      <daum-post @complete="completeZipCode" />
                    </v-dialog>
                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt small">수령인명 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-text-field v-model="order.name" :rules="[rules.required]" label="" dense flat clearable/>
                  </v-col>
                </dd>
                <dt class="formInfoTxt small">배송지 연락처 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-text-field v-model="order.mobileNo" :rules="[rules.required]" label="" dense flat clearable/>
                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt small">신청 제품 <i class="fa fa-asterisk" aria-hidden="true"/>

                  <v-btn color="primary" @click="dialogProducts = true" dark small>
                    <v-icon small class="mr-2">mdi mdi-pencil</v-icon>
                    제품 변경
                  </v-btn>
                </dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
<!--                    {{ order.presentProductId }} - -->
<!--                    {{ order.productId }} - -->
                    {{ order.orderProductName }}
                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt small">신청 상태  <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-radio-group v-model="order.orderState" row>
                      <v-radio
                          v-for="(o, idx) in orderTypes"
                          :key="idx"
                          :label="o.text"
                          :value="o.value"
                      ></v-radio>
                    </v-radio-group>

<!--                    <v-switch-->
<!--                        v-model="order.orderState"-->
<!--                        flat-->
<!--                        hide-details-->
<!--                        color="primary"-->
<!--                        true-value="STATE_ORDERED"-->
<!--                        false-value="STATE_CREATED"-->
<!--                        :label="order.orderState === 'STATE_CREATED' ? '신청대기' : '신청완료'"-->
<!--                    ></v-switch>-->
                  </v-col>
                </dd>
                <dt class="formInfoTxt small">신청일 / 발주일</dt>
                <dd class="formInfoArea">
                  <v-col>
                    신청일 : {{ order.orderedAt | moment('YYYY-MM-DD HH:mm:ss')}}
                    <br />
                    <span v-if="order.orderState === 'STATE_COMPLETED'">발주일 : {{ order.shippedDt | moment('YYYY-MM-DD')}}</span>
                  </v-col>
                </dd>
              </dl>
<!--              <dl class="infoCont">-->
<!--                <dt class="formInfoTxt small">신청일</dt>-->
<!--                <dd class="formInfoArea">-->
<!--                  <v-col class="mgr" sm="2">-->
<!--                    <v-menu-->
<!--                        v-model="orderedDateCal"-->
<!--                        :close-on-content-click="false"-->
<!--                        :nudge-right="40"-->
<!--                        transition="scale-transition"-->
<!--                        offset-y-->
<!--                        min-width="290px"-->
<!--                    >-->
<!--                      <template v-slot:activator="{ on, attrs }">-->
<!--                        <v-text-field-->
<!--                            v-model="order.orderedAt"-->
<!--                            label="신청일"-->
<!--                            prepend-icon="mdi-calendar"-->
<!--                            readonly-->
<!--                            clearable-->
<!--                            v-bind="attrs"-->
<!--                            v-on="on"-->
<!--                        ></v-text-field>-->
<!--                        &lt;!&ndash;                :rules="[rules.required]"&ndash;&gt;-->
<!--                      </template>-->
<!--                      <v-date-picker-->
<!--                          v-model="order.orderedAt"-->
<!--                          @input="orderedDateCal = false"-->
<!--                          locale="ko"-->
<!--                      ></v-date-picker>-->
<!--                    </v-menu>-->
<!--                  </v-col>-->
<!--                </dd>-->
<!--              </dl>-->

              <dl class="infoCont">
                <dt class="formInfoTxt small">신청 메세지</dt>
                <dd class="formInfoArea">
                  <v-textarea v-model="order.orderMessage" dense flat />
                </dd>
                <dt class="formInfoTxt small">신청 상태 메모</dt>
                <dd class="formInfoArea">
                  <v-textarea v-model="order.orderStateMemo" dense flat />
                </dd>
              </dl>
            </v-form>
          </div>
        </div>

        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vBtn" color="#fafafa" @click="goList">
              <v-icon left>mdi mdi-format-list-bulleted</v-icon>
              목록
            </v-btn>
<!--            <v-btn class="vBtn" color="#1991eb" dark @click="save">-->
            <v-btn class="vBtn" color="success" dark @click="save">
              <v-icon left>mdi mdi-content-save</v-icon>
              저장
            </v-btn>

          </div>
        </div>

      </div>

    </div>
    <v-dialog
        v-model="dialogProducts"
        persistent
        max-width="1000px"
        @click:outside="dialogProducts = false" @keydown.esc="dialogProducts = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">제품 목록</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <product-list @product-selected="addProduct" :present-id="id"></product-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="dialogProducts = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import presentApi from "@/api/PresentApi";
import orderApi from "@/api/OrderApi";
import ProductList from '../components/PresentProduct'

export default {
  name: "OrderForm",
  props: {
    id: String,
    orderId: Number,
    userId: String
  },
  components: {
    ProductList
  },
  data: () => ({
    orderTypes: [
      {value: 'STATE_CREATED', text: '신청 대기'}
      , {value: 'STATE_ORDERED', text: '신청 완료'}
      , {value: 'STATE_COMPLETED', text: '발주 완료'}
      , {value: 'STATE_CANCELED', text: '신청 취소'}
    ],
    dialogProducts: false,
    daumDialogVisible: false,
    order: {

    },
    present: {
      activated: true
    },
    stateList: [
      {
        value: 'STATE_END',
        text: '마감'
      },
      {
        value: 'STATE_RECEIPT',
        text: '접수중'
      },
      {
        value: 'STATE_READY',
        text: '접수대기'
      },
      {
        value: 'STATE_CANCEL',
        text: '취소'
      },
    ],
    orderedDateCal: false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      maxNumber: value => value && value < 2560 && value > 10 || '허용되지 않는 범위입니다.',
      length20: value => value && value.length > 20 || '필수 입력 항목입니다.',
    }
  }),
  methods: {
    setUserInfo() {
      this.order.zipCode = this.order.user.zipCode;
      this.order.address = this.order.user.address;
      this.order.addressDetail = this.order.user.addressDetail;
      this.order.name = this.order.user.name;
      this.order.mobileNo = this.order.user.mobileNo;
    },
    addProduct(p) {
      this.order.presentProductId = p.presentProductId
      this.order.productId = p.productId
      this.order.orderProductName = p.product.productName
      this.dialogProducts = false;
    },
    openZipCode() {
      this.daumDialogVisible = true;
    },
    completeZipCode(data) {
      this.order.zipCode = data.zonecode
      this.order.address = data.address
      this.daumDialogVisible = false;
    },
    async save() {
      if(!await this.$refs.formOrder.validate())
        return;

      if(!this.order.presentProductId) {
        alert("제품을 선택해주세요.")
        return
      }

      this.order.user = null;
      orderApi.save(this.order).then(data => {
        if (data) {
          alert("저장되었습니다.");
          this.goList();
        } else {
          alert("Error");
        }
      });
    },
    goList() {
      this.$emit("callback-type", {
        type: 'list'
      })
    },
  },
  created() {
    if (this.id) {
      orderApi.get(this.orderId).then(data => {
        this.order = data;
      });

      presentApi.get(this.id).then(data => {
        this.present = data;
      });
    }
  }
}
</script>


<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}
.dashRow:first-child {
  flex: 0 1 100%;

  &:first-child {
    margin-right: 1%;
  }
}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>